import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { graphql, DataProps } from 'react-apollo';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import Modal from 'shared/components/Modal';
import { actions as appActions } from 'actions';
import { FirstLoginModalQuery } from './__generated__/FirstLoginModalQuery';
import * as query from './query.gql';

import './index.scss';

interface Props {}

const b = b_.with('first-login-modal');

const dispatchProps = {
  close: () => appActions.toggleFirstLoginModal(false),
};

type Enhanced = Props &
  InjectedTranslateProps &
  typeof dispatchProps &
  DataProps<FirstLoginModalQuery>;

const enhance = compose<Enhanced, Props>(
  translate,
  connect(undefined, dispatchProps),
  graphql<Props, FirstLoginModalQuery>(query)
);

class FirstLoginModal extends React.Component<Enhanced> {
  render() {
    const { t, close, data } = this.props;

    if (!data || !data.userDirectory || !data.userDirectory.me) {
      return null;
    }

    const { firstName, email } = data.userDirectory.me;

    return (
      <Modal onClose={close}>
        <section className={b('section')}>
          <h2>{t('Dear {{firstName}}', { firstName })},</h2>
          <p>{t('We sent instructions to {{email}}', { email })}</p>
          <p>{t('Here you can select an investment idea and build your investment portfolio')}</p>
          <button className={b('btn')} onClick={close}>
            {t('Next')}
          </button>
        </section>
      </Modal>
    );
  }
}

export default enhance(FirstLoginModal);
